import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { HiOutlineInformationCircle } from "react-icons/hi";

const AddOrgModal = ({ onClose, onSave, editingOrg, isPending = false }) => {
  const [form, setForm] = useState({
    name: editingOrg?.organizationsName || "",
    code: editingOrg?.organizationsCode || "",
    desc: editingOrg?.description || "",
    storage: editingOrg?.storageLimit?.toString() || "50",
    unit: "GB",
    status: editingOrg ? editingOrg.isActive : true,
  });

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-150">
      <div className="bg-white rounded-2xl shadow-2xl w-full md:w-1/2 lg:w-1/4 mx-4 animate-in zoom-in-95 duration-150">
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-100">
          <div>
            <h2 className="text-base font-bold text-slate-900">
              {editingOrg ? "Edit Organization" : "Add Organization"}
            </h2>
          </div>
          <button
            onClick={onClose}
            disabled={isPending}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <IoClose size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">
          {/* Organization Name */}
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Organization Name <span className="text-red-500">*</span>
            </label>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Enter organization name"
              className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all placeholder-slate-400"
            />
          </div>
          <p className="text-xs text-slate-500 mt-0.5">
            A default folder structure will be created automatically.          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 pb-6 pt-4 border-t border-slate-100">
          <button
            onClick={onClose}
            disabled={isPending}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={async () => {
              if (form.name.trim()) {
                try {
                  await onSave(form);
                } catch (err) {
                  console.error(err);
                }
              }
            }}
            disabled={!form.name.trim() || isPending}
            className="px-5 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-colors shadow-sm shadow-indigo-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? (editingOrg ? "Updating..." : "Creating...") : (editingOrg ? "Update" : "Create")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOrgModal;
